import {useGetList} from 'src/feature/store/context/useQuery'
import {useStore} from 'src/feature/store/hook'
import ProviderDetail from './detail'

function Dashboard() {
  const {list} = useStore()
  const {isLoading} = useGetList()

  return (
    <>
      <ProviderDetail storeData={list} />
    </>
  )
}

export default Dashboard
